import {ActionCreator, createReducer} from '../../../store/utils';
import type {QuickReply, Pagination} from '../../../entities';

export type QuickReplyState = {
  quickReplies: QuickReply[],
  pagination?: Pagination,
};

export type QuickReplyAction = {
  quickReply: QuickReply,
  quickReplyId: string,
  quickReplies: QuickReply[],
  pagination?: Pagination,
  page?: number,
};

export const initialState: QuickReplyState = {
  quickReplies: [],
};

export class SetQuickReplies extends ActionCreator<QuickReplyAction> {}
export class AddQuickReply extends ActionCreator<QuickReplyAction> {}
export class EditQuickReply extends ActionCreator<QuickReplyAction> {}
export class DeleteQuickReply extends ActionCreator<QuickReplyAction> {}

export class SetPaginationPage extends ActionCreator<QuickReplyAction> {}

export const actions = {
  setQuickReplies: (quickReplies: QuickReply[], pagination: Pagination) =>
    new SetQuickReplies({
      quickReplies,
      pagination,
    }),
  addQuickReply: (quickReply: QuickReply) =>
    new AddQuickReply({
      quickReply,
    }),
  editQuickReply: (quickReply: QuickReply) =>
    new EditQuickReply({
      quickReply,
    }),
  deleteQuickReply: (quickReplyId: string) =>
    new DeleteQuickReply({
      quickReplyId,
    }),

  setPaginationPage: (page: number) => new SetPaginationPage({page}),
};

export default createReducer(initialState, {
  [SetQuickReplies.type]: (
    state: QuickReplyState,
    action: QuickReplyAction
  ) => ({
    ...state,
    quickReplies: action.quickReplies,
    pagination: action.pagination,
  }),
  [AddQuickReply.type]: (state: QuickReplyState, action: QuickReplyAction) => ({
    ...state,
    quickReplies: [...state.quickReplies, action.quickReply],
  }),
  [EditQuickReply.type]: (
    state: QuickReplyState,
    action: QuickReplyAction
  ) => ({
    ...state,
    quickReplies: state.quickReplies.map(quickReply =>
      quickReply.id === action.quickReply.id ? action.quickReply : quickReply
    ),
  }),
  [DeleteQuickReply.type]: (
    state: QuickReplyState,
    action: QuickReplyAction
  ) => ({
    ...state,
    quickReplies: state.quickReplies.filter(
      quickReply => quickReply.id !== action.quickReplyId
    ),
  }),
  [SetPaginationPage.type]: (
    state: QuickReplyState,
    action: QuickReplyAction
  ) => ({
    ...state,
    pagination: {
      ...state.pagination,
      page: action.page,
    },
  }),
});
